import { TableSize } from '@/components/common/table-size'
import { useSizeTableBySlug } from '@/hooks/react-query/size/use-size'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { SizeFormatter } from '@/services/formatter/__f.size'
import Image from 'next/image'
import { useMemo } from 'react'

type SizeTableMaleContentProps = {
  sizeChart?: string
}

export const SizeTableMaleContent = ({
  sizeChart,
}: SizeTableMaleContentProps) => {
  const { data, isLoading } = useSizeTableBySlug(sizeChart || '')

  const tableData = useMemo(() => {
    if (!data) {
      return {
        rows: [],
        columns: [],
        matrix: [],
        image: '',
        headerTitle: '',
        leftTitle: '',
        title: '',
      }
    }

    return SizeFormatter.formatSizeTable(data)
  }, [data])

  const isJeanOrShort = useMemo(() => {
    return sizeChart?.includes('jean') || sizeChart?.includes('short')
  }, [sizeChart])

  if (isLoading) {
    return (
      <div className='py-4 text-center'>
        <h3 className='text-lg font-medium'>Đang tải bảng size...</h3>
      </div>
    )
  }

  if (!tableData.rows.length) {
    return (
      <div className='py-4 text-center'>
        <h3 className='text-lg font-medium'>Không tìm thấy bảng size</h3>
      </div>
    )
  }

  return (
    <div className='py-4'>
      <TableSize
        rows={tableData.rows}
        columns={tableData.columns}
        matrix={tableData.matrix}
        title='Thông số sản phẩm'
        className='mt-4'
        suffixCol='Size'
        colClassName='min-w-32 text-start'
        itemClassName='min-w-24'
      />

      <div className='my-4 rounded bg-neutral-200 px-4 py-3 font-sans text-sm leading-4.5 text-neutral-800/90'>
        <p className='font-bold'>
          Trường hợp số đo của bạn nằm trong khoảng giữa các size với nhau:
        </p>
        <ul className='list-disc pl-4'>
          {isJeanOrShort ? (
            <>
              <li>Với quần, bạn hãy lựa chọn ưu tiên theo cân nặng</li>
              <li>
                Ví dụ chiều cao của bạn theo size M nhưng cân nặng theo size L.
                Hãy chọn L.
              </li>
            </>
          ) : (
            <>
              <li>Với áo thun, bạn hãy lựa chọn ưu tiên theo chiều cao</li>
              <li>
                Ví dụ chiều cao của bạn theo size L nhưng cân nặng của bạn theo
                size M, hãy chọn L.
              </li>
            </>
          )}
          <li>97% khách hàng của chúng tôi đã chọn đúng size theo cách này.</li>
        </ul>
      </div>
      {tableData.image && (
        <div className='mb-4 flex justify-center'>
          <Image
            src={ImageHelper.getImageUrl(tableData.image)}
            alt='Size chart'
            width={500}
            height={300}
            className='w-full rounded-lg object-contain'
            unoptimized
          />
        </div>
      )}
    </div>
  )
}
